import Vue from 'vue'
import 'vue-chartist/node_modules/chartist/dist/chartist.min.css'

Vue.use(require('vue-chartist'))
